export default "__VITE_ASSET__BH_N4Ayz__"